import { Tenant } from '@allbesmart/web-app-common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'oaibox-tenant-info',
    templateUrl: './tenant-info.component.html',
    styleUrl: './tenant-info.component.css',
})
export class TenantInfoComponent {

  @Input({ required: true }) tenant!: Tenant;

}
